import {
    ChangeDetectorRef,
    Directive,
    Input,
    OnDestroy,
    OnInit,
    TemplateRef,
    ViewContainerRef,
    inject,
} from "@angular/core";
import { Subscription } from "rxjs";

import { type FeatureFlagName } from "../constants/feature-flags.constant";
import { FeatureFlagFacade } from "../facades/feature-flag.facade";

@Directive({ selector: "[hFeatureFlag]" })
export class FeatureFlagDirective implements OnInit, OnDestroy {
    private vcr = inject(ViewContainerRef);
    private templateReference = inject<TemplateRef<unknown>>(TemplateRef);
    private featureFlagFacade = inject(FeatureFlagFacade);
    private cdr = inject(ChangeDetectorRef);

    @Input()
    public hFeatureFlag!: FeatureFlagName;

    @Input()
    public hFeatureFlagElse!: TemplateRef<unknown>;

    private subscription: Subscription = new Subscription();

    public ngOnInit(): void {
        this.subscription.add(
            this.featureFlagFacade
                .isActivated(this.hFeatureFlag)
                .subscribe((isActivated: boolean) => {
                    this.displayTemplate(
                        isActivated
                            ? this.templateReference
                            : this.hFeatureFlagElse,
                    );
                }),
        );
    }

    public ngOnDestroy(): void {
        this.subscription.unsubscribe();
    }

    /**
     * display template
     */
    protected displayTemplate(template: TemplateRef<unknown>): void {
        if (template) {
            this.vcr.createEmbeddedView(template);
            this.cdr.detectChanges();
        }
    }
}
